// We load the Vimeo player SDK after page load so it doesn't cost us CWV
function load_vimeo_sdk()
{
  return new Promise((resolve, reject) =>
  {
    if (window.Vimeo && window.Vimeo.Player) return resolve()
    const s = document.createElement('script')
    s.src = 'https://player.vimeo.com/api/player.js'
    s.async = true
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
}

// Listen for the Vimeo video to start playing, then fade out the placeholder image
function listen_for_vimeo_playing()
{
  document.querySelectorAll('iframe[data-vimeo-hero-video]').forEach((el) =>
  {
    const player = new Vimeo.Player(el)
    let started = false

    const onPlay = () =>
    {
      if (started) return
      started = true
      player.off('play', onPlay)
      player.off('timeupdate', onTimeupdate)

      const container = el.closest('[data-hero-video-container]')
      if (container)
      {
        container.classList.add('video_loaded')
      }
    }

    const onTimeupdate = (e) =>
    {
      if (started) return
      if (e.seconds > 0)
      {
        started = true
        player.off('play', onPlay)
        player.off('timeupdate', onTimeupdate)

        const container = el.closest('[data-hero-video-container]')
        if (container)
        {
          container.classList.add('video_loaded')
        }
      }
    }

    player.on('play', onPlay)
    player.on('timeupdate', onTimeupdate)
  })
}

window.addEventListener('load', () =>
{
  load_vimeo_sdk()
    .then(listen_for_vimeo_playing)
    .catch((err) =>
    {
      console.error('Vimeo SDK failed to load or init', err)

      // Retry once after 3s without blocking the UI
      setTimeout(() =>
      {
        load_vimeo_sdk()
          .then(listen_for_vimeo_playing)
          .catch(() => {})
      }, 3000)
    })
})
